import React, { useState } from "react";
import Modal from "../modals/Modal";
import ModalMobile from "../modals/ModalMobile";
import { selectCurrency, selectId, selectLogged, selectToken, selectUser, selectTipo, selectBlockRetiro } from "../../features/user/userSlice";
import { useSelector, useDispatch } from "react-redux";

import {
  selectDepositModal,
  selectWithdrawModal,
  setShowJumio,
  setShowUserDepositModal,
  setUrlverify,
} from "../../features/modals/modalsSlice";
import {
  ButtonClose,
  Container,
  Content,
  ContentSecondary,
  ContentSecondaryBody,
  MenuCard,
  MenuTop,
  ModalTitle,
} from "./DepositElements";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";
import FormWrapper from "./FormWrapper";
import MainView from "./MainView";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import HistoryIcon from "@mui/icons-material/History";
import MovementsContent from "../userMovements/MovementsContent";
import HistoryContent from "../userHistory/HistoryContent";
import PaymentsIcon from "@mui/icons-material/Payments";
import PaymentMethodWithdraw from "./PaymentMethodWithdraw";
import MainViewWithdraw from "./MainViewWithdraw";
import { useEffect } from "react";
import { API_URL } from "../../const/api";
import axios from "axios";
import { selectLimites } from "../../features/limitaciones/limitacionesSlice";
import { errorNotification, infoNotification } from "../../utils/toastNotifications";
import Swal from "sweetalert2";
import { PRIMARY, SECONDARY } from "../../const/colors";
import SwalBlockRetiro from "../SwalBlockRetiro";

const Deposit = () => {
  const isLoged = useSelector(selectLogged);
  const depositModal = useSelector(selectDepositModal);
  const withdrawModal = useSelector(selectWithdrawModal);
  const usuario = useSelector(selectUser);
  const moneda = useSelector(selectCurrency);
  const id_uo = useSelector(selectId);
  const token = useSelector(selectToken);
  const [route, setRoute] = useState("deposito");
  const [activeDepositMethod, setActiveDepositMethod] = useState(null);
  const [activeWithdrawMethod, setActiveWithdrawMethod] = useState(null);
  const [mostrarRetailer, setMostrarRetailer] = useState(false);
  const [bancosRetailer, setBancosRetailer] = useState([]);
  const dispatch = useDispatch();
  const [t] = useTranslation("global");
  const tipo = useSelector(selectTipo);

  const blockRetiro = useSelector(selectBlockRetiro)

  const limitaciones = useSelector(selectLimites)

  const verificacionJumio = async () => {
    let body = {
      id_uo,
      token,
    };
    const res = await axios.post(API_URL + "verify", body);
    if (res.data.code === 200) {
      dispatch(setUrlverify(res.data.response_data.web.href));
      dispatch(setShowJumio(true));
    } else {
      if (res.data.message) {
        errorNotification(res.data.message, "top-center");
      } else {
        errorNotification(t("alert.errorNotificationRetiro-66"), "top-center");
      }
    }
  }

  const handleChangeRoute = (newRoute) => {
    if(newRoute==='deposito' && Number(limitaciones.tiempo_inactivo)>0) {
      infoNotification("Su cuenta se encuentra inactiva por indicaciones del usuario.")
    } else if(newRoute==='retiro' && blockRetiro) {
      SwalBlockRetiro(verificacionJumio)
    } else {
      setRoute(newRoute)
    }
  }

  const submenu = [
    {
      title: t("deposit.deposit"),
      icon: <AccountBalanceIcon />,
      margin: false,
      route: "deposito",
    },
    {
      title: t("deposit.withdraw"),
      icon: <PaymentsIcon />,
      margin: false,
      route: "retiro",
    },
    {
      title: t("deposit.movements"),
      icon: <TrendingUpIcon />,
      margin: false,
      route: "movimientos",
    },
    {
      title: t("deposit.history"),
      icon: <HistoryIcon />,
      margin: true,
      route: "historial",
    },
  ];

  const handleClose = () => {
    dispatch(setShowUserDepositModal({open: false, type: false}));
  };

  const handleActiveDepositMethod = (method) => {
    setActiveDepositMethod(method);
  };
  const handleActiveWithdrawMethod = (method) => {
    setActiveWithdrawMethod(method);
  };

  const handleExit = () => {
    setActiveDepositMethod(null);
    setActiveWithdrawMethod(null);
  };

  useEffect(() => {
    setActiveDepositMethod(null);
    setActiveWithdrawMethod(null);
  }, [route]);

  useEffect(()=>{
    if(withdrawModal) setRoute('retiro')
  },[])


  useEffect(()=>{
    const loadRetailer = async () => {
      const body = {
        id_uo, token, moneda
      }
      if((usuario.toLowerCase()==='danielbritosol' || usuario==='test'||usuario==='test2'||usuario==='test3'||usuario.toLowerCase()==='test4'||usuario.toLowerCase()==='test5'||usuario.toLowerCase()==='test6'||usuario==='testbrasil'||usuario==='test6')&&(moneda==='$'||moneda==='BRL'||moneda==='CLP'||moneda==='MXN'||moneda==='COP'||moneda==='CRC'||moneda==='Sol'||moneda==='ARS')) {
        if(moneda==='$') {
          const resTlf = await axios.post(API_URL+'getPais', body);
          if(resTlf.data) {
            if(resTlf.data.response===1) setMostrarRetailer(true);
            else setMostrarRetailer(false);
          }
        } else setMostrarRetailer(true);
      } else setMostrarRetailer(false);
    }

    loadRetailer();
  },[])

  return (
    isLoged && (
      <>
        <Modal
          open={depositModal}
          handleClose={handleClose}
          maxWidth="md"
          fullWidth={true}
          children={
            <Container>
              <ModalTitle>
                <h2>{t(`deposit.transactions`)}</h2>
                <ButtonClose onClick={handleClose}>
                  <CloseIcon />
                </ButtonClose>
              </ModalTitle>
              <MenuTop>
                {submenu.map((item, i) => (
                  <MenuCard
                    margin={item.margin}
                    key={i}
                    className={route === item.route ? "active" : null}
                    onClick={() => handleChangeRoute(item.route)}
                  >
                    {item.icon} <span>{item.title}</span>
                  </MenuCard>
                ))}
              </MenuTop>
              {(route === "deposito") && (
                <Content>
                  <FormWrapper
                    handleActiveDepositMethod={handleActiveDepositMethod}
                    selected={activeDepositMethod}
                    actPayRetailer={mostrarRetailer}
                  />

                  <MainView
                    depositMethod={activeDepositMethod}
                    handleExit={handleExit}
                  />
                </Content>
              )}

              {route === "retiro" && !blockRetiro && (
                <Content>
                  <PaymentMethodWithdraw
                    handleActiveWithdrawMethod={handleActiveWithdrawMethod}
                    selected={activeWithdrawMethod}
                    actPayRetailer={mostrarRetailer}
                  />
                  <MainViewWithdraw
                    withdrawMethod={activeWithdrawMethod}
                    handleExit={handleExit}
                  />
                </Content>
              )}

              {route === "movimientos" && (
                <ContentSecondary>
                  <ContentSecondaryBody>
                    <MovementsContent />
                  </ContentSecondaryBody>
                </ContentSecondary>
              )}

              {route === "historial" && (
                <ContentSecondary>
                  <ContentSecondaryBody>
                    <HistoryContent />
                  </ContentSecondaryBody>
                </ContentSecondary>
              )}
            </Container>
          }
        />

        <ModalMobile
          open={depositModal}
          handleClose={handleClose}
          children={
            <Container>
              <ModalTitle>
                <h2>{t(`deposit.transactions`)}</h2>
                <ButtonClose onClick={handleClose}>
                  <CloseIcon />
                </ButtonClose>
              </ModalTitle>
              <MenuTop>
                {submenu.map((item, i) => (
                  <MenuCard
                    margin={item.margin}
                    key={i}
                    className={route === item.route ? "active" : null}
                    onClick={() => handleChangeRoute(item.route)}
                  >
                    {item.icon} <span>{item.title}</span>
                  </MenuCard>
                ))}
              </MenuTop>
              {route === "deposito" && (
                <Content>
                  <FormWrapper
                    handleActiveDepositMethod={handleActiveDepositMethod}
                    selected={activeDepositMethod}
                  />

                  <MainView
                    depositMethod={activeDepositMethod}
                    handleExit={handleExit}
                  />
                </Content>
              )}

              {route === "retiro" && (
                <Content>
                  <PaymentMethodWithdraw
                    handleActiveWithdrawMethod={handleActiveWithdrawMethod}
                    selected={activeWithdrawMethod}
                  />
                  <MainViewWithdraw
                    withdrawMethod={activeWithdrawMethod}
                    handleExit={handleExit}
                  />
                </Content>
              )}

              {route === "movimientos" && (
                <ContentSecondary>
                  <ContentSecondaryBody>
                    <MovementsContent btnBack={true} />
                  </ContentSecondaryBody>
                </ContentSecondary>
              )}

              {route === "historial" && (
                <ContentSecondary>
                  <ContentSecondaryBody>
                    <HistoryContent btnBack={true} />
                  </ContentSecondaryBody>
                </ContentSecondary>
              )}
            </Container>
          }
        />
      </>
    )
  );
};

export default Deposit;
